
import styles from './Community.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { TableList } from "../../../components";
import common from '../../../common';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Community() {

    
    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [data4, setData4] = useState([]);

    const fetchData = async () => {
        try {
            pLoadingOn();
            // const cateValues = [3, 8, 9, 10];
            // const cateValues = [10, 3, 8, 9];
            const cateValues = [12, 3, 13, 14];
            
            // 모든 요청을 병렬로 실행
            const responses = await Promise.all(
                cateValues.map(cate =>
                    axios.post(`${API_BASE_URL}/yehs_document/out/get_table`, 
                        { tableType: 'Notice', type: 'do', cate: [cate] }, 
                        { withCredentials: true }
                    )
                )
            );

            // 응답 처리
            const [data1, data2, data3, data4] = responses.map(response => {
                if (response.data.result === 't') {
                    return response.data.data;
                } else {
                    pAlert(response.data.msg);
                    return [];
                }
            });

            setData1(data1);
            setData2(data2);
            setData3(data3);
            setData4(data4);
            

        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const columns = useMemo(() => [
        { title: '제목', dataIndex: 'title', className: 'p_td_w_330 text_start' },
        { title: '등록일', dataIndex: 'createTime', className: '' },
        { title: '작성자', dataIndex: 'member', className: '' },
    ], []);

    const pageSize = 5;
    const categoryOptions = useMemo(() => [], []);


    return (
        <>
            <div className="components_wrap">
                <div className={`${styles.community_wrap}`}>
                    <div className={styles.community_box}>
                        <div className={styles.community_half_box}>
                            <span className='components_wrap_title'>행사</span>
                            <TableList data={data1} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Editor"}/>
                        </div>
                        
                        <div className={styles.community_half_box}>
                            <span className='components_wrap_title'>홍보게시판</span>
                            <TableList data={data2} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Editor"}/>
                        </div>
                        
                    </div>
                </div>
                <div className={`${styles.community_wrap}`}>
                    <div className={styles.community_box}>
                        <div className={styles.community_half_box}>
                            <span className='components_wrap_title'>YEHStudy</span>
                            <TableList data={data3} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Editor"}/>
                        </div>
                        <div className={styles.community_half_box}>
                            <span className='components_wrap_title'>YEHS 소모임</span>
                            <TableList data={data4} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type={"Editor"}/>
                        </div>
                        
                        
                    </div>
                </div>
            </div>
        </>
    );
}

export default Community;